module.exports = __webpack_public_path__ + "img/instagram.d6c28abc.svg";